export default __webpack_public_path__ + "fonts/investor-subject-pin.svg";